(function () {
  'use strict';

  var modules = [
    'ifh.ENV',
    'ngAnimate',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ui.router',
    'ngMaterial',
    'ngScrollbars',
    'duScroll',
    'uiGmapgoogle-maps',
    'slickCarousel'
  ];

  angular.module('ifh', modules);
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .controller('TeamController', TeamController);

  /** @ngInject */
  function TeamController($scope, $rootScope, $timeout, StaffService) {
    var vm = this;

    vm.data = StaffService.getData();

    vm.memberDialog = {
      open: false
    };

    vm.getWidth = getWidth;
    vm.triggerMenuActiveLinkUpdate = triggerMenuActiveLinkUpdate;

    init();

    function init() {
      var destroyListener = $rootScope.$on('client.team-tab-change', function (event, tab) {
        vm.activeTab = tab;
      });

      $scope.$on('$destroy', destroyListener);

      vm.activeTab = vm.activeTab || 0;
      $timeout(triggerMenuActiveLinkUpdate, 500)
    }

    function getWidth(qty) {
      if (qty % 4 === 0) {
        return 25;
      } else if (qty % 3 === 0) {
        return 33;
      } else {
        return 25;
      }
    }

    function triggerMenuActiveLinkUpdate() {
      $rootScope.$broadcast('menu-link-change', {
        state: 'client.team',
        tab: vm.activeTab
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .controller('StrategyController', StrategyController);

  /** @ngInject */
  function StrategyController() {
    //var vm = this;
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .controller('ProjectsController', ProjectsController);

  /** @ngInject */
  function ProjectsController($scope, $rootScope, $timeout, ProjectsService) {
    var vm = this;

    vm.activeTab = 0;
    vm.data = ProjectsService.getData();

    vm.showCurrent = showCurrent;
    vm.showProjectTypeSelect = showProjectTypeSelect;
    vm.showFinishedProjects = showFinishedProjects;
    vm.triggerMenuActiveLinkUpdate = triggerMenuActiveLinkUpdate;

    init();

    function init() {
      var destroyListener = $rootScope.$on('client.projects-tab-change', function (event, tab) {
        vm.activeTab = tab;
      });

      $scope.$on('$destroy', destroyListener);

      vm.activeTab = vm.activeTab || 0;
      $timeout(triggerMenuActiveLinkUpdate, 500);
    }

    function showCurrent(type) {
      vm.currentProjects = vm.data.data.current[type].list;
      vm.currentType = type;
      vm.showCurrentList = true;
    }

    function showProjectTypeSelect() {
      vm.activeTab = 0;
      vm.showCurrentList = false;
      vm.currentType = undefined;
      vm.currentProjects = [];
      triggerMenuActiveLinkUpdate();
    }

    function showFinishedProjects() {
      vm.activeTab = 1;
      vm.showCurrentList = false;
      vm.currentType = undefined;
      vm.currentProjects = [];
      triggerMenuActiveLinkUpdate();
    }

    function triggerMenuActiveLinkUpdate() {
      $rootScope.$broadcast('menu-link-change', {
        state: 'client.projects',
        tab: vm.activeTab
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .controller('NewsController', NewsController);

  /** @ngInject */
  function NewsController($timeout, $window, $sce, NewsService, ENV) {
    var vm = this;

    vm.imgPrefix = ENV.api;
    vm.data = NewsService.getData();
    vm.config = {
      autoHideScrollbar: false,
      theme: 'minimal-dark',
      advanced: {
        updateOnContentResize: true
      },
      scrollInertia: 0
    };
    vm.newsDialog = {
      open: false
    };

    vm.setContent = setContent;
    vm.initContent = initContent;
    vm.trustSrc = trustSrc;

    function setContent(index, type) {
      setNewsData(index, type);

      if ($window.window.innerWidth < 960) {
        angular.element('body').addClass('no-scroll');
        vm.newsDialog.content = vm.activeNewsArticle;
        vm.newsDialog.open = true;
      }

      return false;
    }

    function setNewsData(index, type) {
      var news = vm.data.data[type];
      var content, searchString, replaceString;

      if (!news || !news.length) {
        return;
      }

      vm.activeNewsArticle = angular.copy(news[index]);

      content = news[index].content || '';

      if ((vm.activeTab === 0 || vm.activeTab === 2) && content) {
        searchString = 'img src="/InterforumHoldings/';
        replaceString = 'img src="' + ENV.api + 'InterforumHoldings/';
        vm.activeNewsArticle.content = content.replace(searchString, replaceString);
      }

      vm.activeContentIndex = index;

      $timeout(function () {
        angular.element('.mCSB_container')[1].style.top = 0;
      });
    }

    function initContent(type) {
      var news = vm.data.data[type];

      if (news && news.length) {
        selectFirst();
      } else {
        NewsService.onFetch(selectFirst);
      }

      function selectFirst() {
        setNewsData(0, type);
      }
    }

    function trustSrc(src) {
      var addition = ENV.api === 'http://localhost:3003' ? ENV.api : $window.location.origin + ENV.api;
      addition += src;
      var url = 'http://docs.google.com/gview?url=' + addition + '&embedded=true';

      return $sce.trustAsResourceUrl(url);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($scope, $interval, $timeout, $window, ENV, StatsService, BannerService) {
    var vm = this;
    var i = 0;
    var count = 5;
    var current = 1;
    var next = 2;
    var destroySlider;

    vm.videoDialog = {
      open: false
    };

    vm.banners = BannerService.getData();
    vm.stats = StatsService.getData();
    vm.imgPrefix = ENV.api;

    vm.openVideoPopup = openVideoPopup;

    init();

    function slideBackground() {
      if (!i) {
        angular.element('.home-slider')
          .find('.next')
          .addClass('show slide-' + next);
        i = 1;
      } else {
        angular.element('.home-slider')
          .find('.next')
          .removeClass('show slide-' + next)
          .prev()
          .removeClass('slide-' + current)
          .addClass('slide-' + next);
        i = 0;
        current = (count > current) ? (current + 1) : 1;
        next = (count != next) ? (next + 1) : 1;
      }
    }

    function init() {
      BannerService.fetch();
      StatsService.fetch();

      if ($window.window.innerWidth >= 960) {
        $timeout(function () {
          destroySlider = $interval(slideBackground, 2500);

          $scope.$on('$destroy', function () {
            $interval.cancel(destroySlider);
          });
        }, 2500);
      }
    }

    function openVideoPopup() {
      vm.videoDialog.open = true;
      vm.videoDialog.video = 'ss';
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .controller('ContactUsController', ContactUsController);

  /** @ngInject */
  function ContactUsController($window, $timeout, ContactService, uiGmapIsReady) {
    var vm = this;

    vm.data = ContactService.getData();

    vm.getInTouch = function () {
      vm.submitted = true;

      if (vm.form.$valid) {
        ContactService.getInTouch();
      }
    };

    vm.map = {
      center: {
        latitude: 42.107012,
        longitude: -87.772450
      },
      control: {},
      refresh: true,
      zoom: 18,
      marker: {
        idKey: 'marker1',
        coords: {
          latitude: 42.107012,
          longitude: -87.772450
        }
      }
    };


    uiGmapIsReady.promise(1).then(function () {
      var gmap = vm.map.control.getGMap();

      new $window.google.maps.Marker({
        position: {
          lat: 42.107012,
          lng: -87.772450
        },
        map: gmap,
        title: ''
      });
      $timeout(triggerResize, 2000);
      $timeout(triggerResize, 3000);
      $timeout(triggerResize, 5000);

      function triggerResize() {
        vm.map.control.refresh({
          latitude: 42.107012,
          longitude: -87.772450
        });
        $window.dispatchEvent(new Event('resize'));
      }



    });
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhVideoDialog', ifhVideoDialog);

  /** @ngInject */
  function ifhVideoDialog() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/video-dialog/video-dialog.html',
      scope: {
        data: '='
      },
      controller: ClientVideoDialogController,
      controllerAs: 'vm',
      bindToController: true
    };

    /** @ngInject */
    function ClientVideoDialogController() {
      var vm = this;

      vm.closeDialog = closeDialog;

      function closeDialog() {
        vm.data.open = false;
        angular.element('body').removeClass('no-scroll');
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhTeamMemberDialog', ifhTeamMemberDialog);

  /** @ngInject */
  function ifhTeamMemberDialog() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/team-member-dialog/team-member-dialog.html',
      scope: {
        data: '='
      },
      controller: TeamMemberController,
      controllerAs: 'vm',
      bindToController: true
    };

    /** @ngInject */
    function TeamMemberController($scope, $log, ENV, StaffService) {
      var vm = this;

      vm.imgPrefix = ENV.api;
      vm.staff = StaffService.getData();

      vm.closeDialog = closeDialog;
      vm.previous = previous;
      vm.next = next;

      init();

      function init() {
        var $destroy = $scope.$watch('vm.data.selectedID', updateDialog);
        $scope.$on('$destroy', $destroy);
      }

      function updateDialog(id, oldId) {
        var indexInManagers, indexInExecutives, index;

        if (!id) {
          return;
        }

        indexInExecutives = getIndex(id, vm.staff.executives);
        indexInManagers = getIndex(id, vm.staff.managers);

        if (indexInExecutives > -1) {
          vm.members = vm.staff.executives;
          index = indexInExecutives;
        } else if (indexInManagers > -1) {
          vm.members = vm.staff.managers;
          index = indexInManagers;
        }

        vm.currentMember = vm.members[index];
        vm.previous = vm.members[index - 1];
        vm.next = vm.members[index + 1];

        if (id && !oldId) {
          enableKeyListeners();
        }

        function getIndex(id, arr) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === id) {
              return i;
            }
          }

          return -1;
        }

        function enableKeyListeners() {
          angular.element('body').on('keydown', onKeyDown);
        }
      }

      function previous() {
        $scope.$applyAsync(function () {
          if (vm.previous && vm.previous.id) {
            vm.data.selectedID = vm.previous.id;
          }
        });
      }

      function next() {
        $scope.$applyAsync(function () {
          if (vm.next && vm.next.id) {
            vm.data.selectedID = vm.next.id;
          }
        });
      }

      function onKeyDown(event) {
        if (event.keyCode === 37) {
          previous();
        } else if (event.keyCode === 39) {
          next();
        }
      }

      function closeDialog() {
        vm.data.open = false;
        vm.data.selectedID = null;
        angular.element('body').off('keydown', onKeyDown);
        angular.element('body').removeClass('no-scroll');
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhTeamMember', ifhTeamMember);

  /** @ngInject */
  function ifhTeamMember(ENV) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/team-member/team-member.html',
      scope: {
        member: '=',
        dialogData: '='
      },
      controller: MemberController,
      controllerAs: 'vm',
      bindToController: true
    };

    /** @ngInject */
    function MemberController() {
      var vm = this;

      vm.imgPrefix = ENV.api;

      vm.openMemberDialog = openMemberDialog;

      function openMemberDialog() {
        angular.element('body').addClass('no-scroll');
        vm.dialogData.selectedID = vm.member.id;
        vm.dialogData.open = true;
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhSplitter', ifhSplitter);

  /** @ngInject */
  function ifhSplitter() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/splitter/splitter.html',
      scope: {
        type: '='
      },
      controller: SplitterController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  function SplitterController() {
    //var vm = this;
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhProjectsTimeline', ifhProjectsTimeline);

  /** @ngInject */
  function ifhProjectsTimeline() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/projects-timeline/proejcts-timeline.html',
      scope: {
        projects: '='
      },
      controller: ProjectsTimelineController,
      controllerAs: 'timeline',
      bindToController: true
    };
  }

  function ProjectsTimelineController($scope, $document) {
    var vm = this;

    vm.data = [];

    vm.scrollTo = scrollTo;

    var $destroy = $scope.$watch('vm.projects', init);
    $scope.$on('$destroy', $destroy);

    function init() {
      var years = [];
      var tempMapping = {};

      if (!vm.projects) {
        return;
      }

      //get distinct years among all projects
      for (var i = 0, len = vm.projects.length; i < len; i++) {
        var project = vm.projects[i];
        var year = (project.year || new Date(project.date).getFullYear()).toString();

        if (years.indexOf(year) === -1) {
          years.push(year);
        }

        tempMapping[year] = tempMapping[year] || {projects: []};
        tempMapping[year].projects.push(project);
      }

      //sort years chronologically
      years.sort();

      //find corresponding projects for each year and build an object like {'1997': {projects: [{}, {}]}}
      for (var j = 0, l = years.length; j < l; j++) {
        vm.data.push({
          year: years[j],
          projects: tempMapping[years[j]].projects
        });
      }
    }

    function scrollTo(year) {
      var wrapper = $document.find('.year' + year);
      $document.duScrollToElementAnimated(wrapper, 0, 600);
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhProjectDialog', ifhNewsDialog);

  /** @ngInject */
  function ifhNewsDialog() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/project-dialog/project-dialog.html',
      scope: {
        data: '='
      },
      controller: ClientProjectDialogController,
      controllerAs: 'vm',
      bindToController: true
    };

    /** @ngInject */
    function ClientProjectDialogController($scope, ENV, ProjectsService) {
      var vm = this;

      vm.imgPrefix = ENV.api;
      vm.projectsList = ProjectsService.getData();

      vm.closeDialog = closeDialog;

      init();

      function init() {
        var $destroy = $scope.$watch('vm.data.selectedID', updateDialog);
        $scope.$on('$destroy', $destroy);
      }

      function updateDialog(id, oldId) {
        var indexInCompleted, indexInCurrent, index, position;
        vm.data.project = {
          images: false
        };

        if (!id) {
          return;
        }

        indexInCompleted = getIndex(id, vm.projectsList.data.completed);

        for (var i = 0; i < vm.projectsList.data.current.length; i++) {
          var result = getIndex(id, vm.projectsList.data.current[i].list);
          if (result > -1) {
            indexInCurrent = result;
            position = i;
          }

        }

        if (indexInCompleted > -1) {
          vm.data.projectsList = vm.projectsList.data.completed;
          index = indexInCompleted;
        } else if (indexInCurrent > -1) {
          vm.data.projectsList = vm.projectsList.data.current[position].list;
          index = indexInCurrent;
        }

        $scope.$applyAsync(function () {
          vm.data.project = vm.data.projectsList[index];
          vm.data.project.numberLoaded = true;
          vm.data.previous = vm.data.projectsList[index - 1];
          vm.data.next = vm.data.projectsList[index + 1];
        });


        if (id && !oldId) {
          enableKeyListeners();
        }

        function getIndex(id, arr) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].id === id) {
              return i;
            }
          }

          return -1;
        }

        function enableKeyListeners() {
          angular.element('body').on('keydown', onKeyDown);
        }
      }

      function previous() {
        $scope.$applyAsync(function () {
          if (vm.previous && vm.previous.id) {
            vm.data.selectedID = vm.data.previous.id;
          }
        });
      }

      function next() {
        $scope.$applyAsync(function () {
          if (vm.next && vm.next.id) {
            vm.data.selectedID = vm.data.next.id;
          }
        });
      }

      function onKeyDown(event) {
        if (event.keyCode === 37) {
          previous();
        } else if (event.keyCode === 39) {
          next();
        }
      }

      function closeDialog() {
        vm.data.open = false;
        angular.element('.js-dialog-content').scrollTop(0);
        angular.element('body').removeClass('no-scroll');
        angular.element('body').off('keydown', onKeyDown);
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhProjectCardCompleted', ifhProjectCardCompleted);

  /** @ngInject */
  function ifhProjectCardCompleted() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/project-card-completed/project-card-completed.html',
      scope: {
        project: '='
      },
      controller: ProjectCardCompletedController,
      controllerAs: 'projectCardCompleted',
      bindToController: true
    };

    /** @ngInject */
    function ProjectCardCompletedController(ENV, $timeout) {
      var vm = this;

      vm.openDialog = openDialog;

      $timeout(_generateRandomImage, 1000);

      vm.projectDialog = {
        open: false
      };

      function openDialog() {
        angular.element('body').addClass('no-scroll');
        vm.projectDialog.open = true;
        vm.projectDialog.selectedID = vm.project.id;
      }

      function _generateRandomImage() {
        var noImageAvailable = 'assets/images/no-thumbnail.png';
        var project = vm.project;
        var images = project.images;
        var qty = images && images.length;
        var random;

        if (!project.thumbnail && !qty) {
          project.timelineImg = noImageAvailable;
        } else if (project.thumbnail && !qty) {
          project.timelineImg = ENV.api + '/InterforumHoldings' + project.thumbnail;
          project.images = ['/InterforumHoldings' + project.thumbnail];
        } else if (project.thumbnail && qty) {
          project.timelineImg = ENV.api + '/InterforumHoldings' + project.thumbnail;
        } else {
          random = Math.floor(Math.random() * qty);
          project.timelineImg = ENV.api + images[random] || noImageAvailable;
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhProjectCard', ifhProjectCard);

  /** @ngInject */
  function ifhProjectCard() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/project-card/project-card.html',
      scope: {
        project: '='
      },
      controller: ProjectCardController,
      controllerAs: 'projectCard',
      bindToController: true
    };

    /** @ngInject */
    function ProjectCardController(ENV, $timeout) {
      var vm = this;

      vm.openDialog = openDialog;

      $timeout(_generateRandomImage, 10);

      vm.projectDialog = {
        open: false
      };

      function openDialog() {
        angular.element('body').addClass('no-scroll');
        vm.projectDialog.open = true;
        vm.projectDialog.selectedID = vm.project.id;
      }

      function _generateRandomImage() {
        var noImageAvailable = 'assets/images/no-thumbnail.png';
        var project = vm.project;
        var images = project.images;
        var qty = images && images.length;
        var random;

        if (!project.thumbnail && !qty) {
          project.timelineImg = noImageAvailable;
        } else if (project.thumbnail && !qty) {
          project.timelineImg = ENV.api + '/InterforumHoldings' + project.thumbnail;
          project.images = ['/InterforumHoldings' + project.thumbnail];
        } else if (project.thumbnail && qty) {
          project.timelineImg = ENV.api + '/InterforumHoldings' + project.thumbnail;
        } else {
          random = Math.floor(Math.random() * qty);
          project.timelineImg = ENV.api + images[random] || noImageAvailable;
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhNewsDialog', ifhNewsDialog);

  /** @ngInject */
  function ifhNewsDialog() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/news-dialog/news-dialog.html',
      scope: {
        data: '='
      },
      controller: ClientNewsDialogController,
      controllerAs: 'vm',
      bindToController: true
    };

    /** @ngInject */
    function ClientNewsDialogController() {
      var vm = this;

      vm.closeDialog = closeDialog;

      function closeDialog() {
        vm.data.open = false;
        angular.element('#news-dialog-content').scrollTop(0);
        angular.element('body').removeClass('no-scroll');
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhNewsCategories', ifhNewsCategories);

  /** @ngInject */
  function ifhNewsCategories() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/news-categories/news-categories.html',
      controller: NewsCategoriesController,
      controllerAs: 'vm'
    };
  }

  function NewsCategoriesController($state, $rootScope) {
    var vm = this;

    vm.activeState = $state.current.name;
    vm.changeType = changeType;

    vm.links = [
      {
        state: 'client.press-releases',
        text: 'menuReleases'
      },
      {
        state: 'client.publications',
        text: 'menuPublications'
      },
      {
        state: 'client.archive',
        text: 'menuArchive'
      },
      {
        state: 'client.testimonials',
        text: 'menuTestimonials'
      }
    ];

    function changeType(state) {
      angular.element('body')[0].scrollTop = 0;
      $state.go(state);
    }

    /*eslint-disable */
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      /*eslint-enable */
      vm.activeState = toState.name;
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhMenuToggle', ifhMenuToggle);

  /** @ngInject */
  function ifhMenuToggle() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/menu-toggle/menu-toggle.html',
      scope: {
        menuOpened: '='
      },
      controller: MenuToggleController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  function MenuToggleController() {
    var vm = this;
    var $body = angular.element('body');

    vm.toggleMenu = toggleMenu;

    function toggleMenu() {
      if (vm.menuOpened) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    function openMenu() {
      vm.menuOpened = true;
      $body.addClass('no-scroll');
    }

    function closeMenu() {
      vm.menuOpened = false;
      $body.removeClass('no-scroll');
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhMenu', ifhMenu);

  /** @ngInject */
  function ifhMenu() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/menu/menu.html',
      scope: {
        opened: '=',
        dictionary: '=',
        scroller: '='
      },
      controller: MenuController,
      controllerAs: 'vm',
      bindToController: true
    };

    /** @ngInject */
    function MenuController($rootScope, $scope, $state, $timeout) {
      var vm = this;

      vm.links = [
        {
          state: 'client.home',
          text: 'menuHome',
          isSubItem: false
        },
        {
          state: 'client.team',
          text: 'menuTeam',
          isSubItem: false
        },
        {
          state: 'client.team',
          text: 'menuAdvisers',
          isSubItem: true,
          activateTab: 0
        },
        {
          state: 'client.team',
          text: 'menuManagers',
          isSubItem: true,
          activateTab: 1
        },
        // {
        //   state: 'client.team',
        //   text: 'menuDirectors',
        //   isSubItem: true,
        //   activateTab: 2
        // },
        {
          state: 'client.strategy',
          text: 'menuInvestmentStrategy',
          isSubItem: false
        },
        {
          state: 'client.projects',
          text: 'menuProjects',
          isSubItem: false
        },
        {
          state: 'client.projects',
          text: 'menuProjectsCurrent',
          isSubItem: true,
          activateTab: 0
        },
        {
          state: 'client.projects',
          text: 'menuProjectsFinished',
          isSubItem: true,
          activateTab: 1
        },
        {
          state: 'client.news',
          text: 'menuNewsRoom',
          isSubItem: false
        },
        {
          state: 'client.press-releases',
          text: 'menuReleases',
          isSubItem: true
        },
        {
          state: 'client.publications',
          text: 'menuPublications',
          isSubItem: true
        },
        {
          state: 'client.archive',
          text: 'menuArchive',
          isSubItem: true
        },
        {
          state: 'client.testimonials',
          text: 'menuTestimonials',
          isSubItem: true
        },
        {
          state: 'client.contact-us',
          text: 'menuContactUs',
          isSubItem: false
        }
      ];

      vm.config = {
        autoHideScrollbar: false,
        theme: 'minimal-dark',
        axis: 'y',
        advanced: {
          updateOnContentResize: true
        },
        scrollInertia: 0
      };

      vm.navigate = navigate;

      init();

      function init() {
        onStateChange($state.current.name);

        var destroyListener = $rootScope.$on('menu-link-change', function (event, data) {
          onStateChange(data.state, data.tab, true);
        });

        $scope.$on('$destroy', destroyListener);
      }

      function navigate(state, tab) {
        var $body = angular.element('body');

        vm.opened = false;
        $body.removeClass('no-scroll');

        $state.go(state);
        $body[0].scrollTop = 0;

        $timeout(function () {
          onStateChange(state, tab);
        }, 300);
      }

      function onStateChange(state, tab, skipEventBroadcast) {
        for (var i = 0; i < vm.links.length; i++) {
          var link = vm.links[i];

          link.isActive = link.state === state && link.activateTab === tab;

          if (link.isActive && (tab || tab === 0) && !skipEventBroadcast) {
            $rootScope.$broadcast(state + '-tab-change', tab);
          }
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhLoginDialog', ifhLoginDialog);

  /** @ngInject */
  function ifhLoginDialog() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/login-dialog/login-dialog.html',
      scope: {
        showing: '='
      },
      controller: LoginController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  /** @ngInject */
  function LoginController($timeout, AdminService) {
    var vm = this;

    vm.credentials = {
      login: '',
      password: ''
    };
    vm.adminData = AdminService.getData();

    vm.login = login;
    vm.closePopUp = closePopUp;

    function login() {
      vm.error = '';

      AdminService.logIn(vm.credentials, onError);

      function onError(msg) {
        vm.error = msg;
      }
    }

    function closePopUp(event) {
      var backdrop;

      if (angular.element(event.target).parents('form').length) {
        return;
      }

      backdrop = angular.element('.backdrop');
      backdrop.addClass('opaque');

      $timeout(function () {
        angular.element('body').removeClass('no-scroll');
        vm.showing = false;

        $timeout(function () {
          backdrop.removeClass('opaque');
        });
      }, 300);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhClientLoader', ifhClientLoader);

  /** @ngInject */
  function ifhClientLoader() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/loader/loader.html',
      scope: {}
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhHeader', ifhHeader);

  /** @ngInject */
  function ifhHeader() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      scope: {
        menuOpened: '=',
        dictionary: '=',
        loginShowing: '='
      },
      controller: HeaderController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  function HeaderController($window) {
    var vm = this;

    vm.openLoginPopup = openLoginPopup;

    function openLoginPopup() {
      // angular.element('body').addClass('no-scroll');
      // vm.loginShowing = true;
      $window.location.href = $window.location.origin + '/personal-area/'
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhFooter', ifhFooter);

  /** @ngInject */
  function ifhFooter() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };
  }

  function FooterController() {
    var vm = this;

    vm.currentYear = new Date().getFullYear();
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .directive('ifhDirectorCard', ifhDirectorCard);

  /** @ngInject */
  function ifhDirectorCard(ENV) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/director-card/director-card.html',
      scope: {
        director: '='
      },
      controller: DirectorController,
      controllerAs: 'vm',
      bindToController: true
    };

    /** @ngInject */
    function DirectorController() {
      var vm = this;

      vm.imgPrefix = ENV.api;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('StatsService', StatsService);

  /** @ngInject */
  function StatsService($resource, ENV) {
    var data = {
      loading: false,
      data: []
    };
    var resource = $resource(ENV.api + '/stats');

    return {
      getData: getData,
      fetch: fetch
    };

    function getData() {
      return data;
    }

    function fetch() {
      data.loading = true;

      resource.get(onSuccess, onError);

      function onSuccess(response) {
        if (!response.success) {
          onError();
        }

        data.data = response.data;
        data.loading = false;
      }

      function onError() {
        data.loading = false;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('StaffService', StaffService);

  /** @ngInject */
  function StaffService($resource, $mdToast, ENV) {
    var data = {
      loading: false,
      managers: [],
      advisers: [],
      directors: []
    };
    var resource = $resource(ENV.api + '/staff/:id', null,
      {
        fetch: {
          method: 'GET'
        }
      });

    return {
      getData: getData,
      fetch: fetch
    };

    function getData() {
      return data;
    }

    function fetch(successCallback) {
      data.fetching = true;
      resource.fetch(onSuccess, onError);

      function onSuccess(response) {
        data.fetching = false;

        if (!response.success) {
          onError();
          return;
        }

        data.executives = [];
        data.managers = [];
        data.directors = [];
        data.advisers = [];

        for (var i = 0, arr = response.data, len = arr.length; i < len; i++) {
          var person = arr[i];

          switch (person.type) {
            case 0:
              data.managers.push(person);
              break;
            case 1:
              data.executives.push(person);
              break;
            case 2:
              data.directors.push(person);
              break;
            case 3:
              data.advisers.push(person);
          }
        }

        data.executives.sort(sort);
        data.managers.sort(sort);
        data.directors.sort(sort);
        data.advisers.sort(sort);

        function sort(a, b) {
          return a.position - b.position;
        }

        successCallback && successCallback();
      }

      function onError() {
        data.fetching = false;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('ProjectsService', ProjectsService);

  /** @ngInject */
  function ProjectsService($resource, ENV) {
    var data = {
      fetching: false,
      data: {}
    };

    return {
      getData: getData,
      fetch: fetch
    };

    function getData() {
      return data;
    }

    function fetch(successCallback) {
      data.fetching = true;
      $resource(ENV.api + '/projects').get(onSuccess, onError);

      function onSuccess(response) {
        var current, completed;

        data.fetching = false;

        if (!response.success) {
          onError();
          return;
        }

        current = response.data.current;
        completed = response.data.completed;

        completed.forEach(addNewLines);
        current.forEach(function (type) {
          type.list.forEach(addNewLines);
        });

        data.data = response.data;
        successCallback && successCallback();

        function addNewLines(proj) {
          proj.description = proj.description.split('\n').join('<br>');
        }
      }

      function onError() {
        data.fetching = false;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('NewsService', NewsService);

  /** @ngInject */
  function NewsService($resource, ENV) {
    var data = {
      loading: false,
      data: {}
    };
    var resource = $resource(ENV.api + '/news/:id', null,
      {
        fetch: {
          method: 'GET'
        }
      });

    return {
      getData: getData,
      fetch: fetch,
      onFetch: onFetch
    };

    function getData() {
      return data;
    }

    function fetch(successCallback) {
      data.fetching = true;
      resource.fetch(onSuccess, onError);

      function onSuccess(response) {
        data.fetching = false;

        if (!response.success) {
          onError();
          return;
        }

        data.data = response.data;

        // if (data.data.testimonials && data.data.testimonials.length > 1) {
        //   data.data.testimonials.reverse();
        // }

        successCallback && successCallback();

        data.onFetch && data.onFetch();
        delete data.onFetch;
      }

      function onError() {
        data.fetching = false;
      }
    }

    function onFetch(callback) {
      data.onFetch = callback;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .service('HttpInterceptors', HttpInterceptors);

  /** @ngInject */
  function HttpInterceptors($q, $log, $injector) {

    return {
      request: function (config) {
        config.timeout = 15000;
        return config;
      },

      response: function (response) {
        return response;
      },

      responseError: function (rejection) {
        var $mdToast = $injector.get('$mdToast');
        var msg = rejection.data && rejection.data.error && rejection.data.error.message || rejection.statusText || 'Unknown Error';

        $log.debug('XHR rejection: ', rejection);
        $mdToast.show($mdToast.simple().textContent(msg).position('top right'));

        return $q.reject(rejection);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('DictionaryService', DictionaryService);

  /** @ngInject */
  function DictionaryService($resource, $timeout, ENV) {
    var data = {
      loading: false,
      data: {}
    };
    var resource = $resource(ENV.api + '/dictionary');

    return {
      getData: getData,
      fetch: fetch
    };

    function getData() {
      return data;
    }

    function fetch(options) {
      data.fetching = true;

      resource.get(onSuccess, onError);

      function onSuccess(response) {
        if (!response.success) {
          onError();
        }

        if (options && options.forClient) {
          _dictionaryToObject(response.data);
        } else {
          data.data = response.data;
        }

        if (options && options.forClient) {
          $timeout(function () {
            data.fetching = false;
          }, 1000);
        } else {
          data.fetching = false;
        }
      }

      function onError() {
        data.fetching = false;
      }
    }

    function _dictionaryToObject(dictionary) {
      data.data = {};

      for (var i = 0, len = dictionary.length; i < len; i++) {
        data.data[dictionary[i].key] = dictionary[i].value;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('ContactService', ContactService);

  /** @ngInject */
  function ContactService($resource, ENV) {
    var dataModel = {
      name: '',
      phone: '',
      email: '',
      question: ''
    };

    var data = {
      data: angular.copy(dataModel),
      submitted: false,
      loading: false
    };

    return {
      getData: getData,
      getInTouch: getInTouch
    };

    function getData() {
      return data;
    }

    function getInTouch() {
      data.fetching = true;
      data.showError = false;

      $resource(ENV.api + '/email').save(data.data, onSuccess, onError);

      function onSuccess() {
        data.fetching = false;
        data.submitted = true;
        data.data = angular.copy(dataModel);
      }

      function onError() {
        data.fetching = false;
        data.showError = true;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('BannerService', BannerService);

  /** @ngInject */
  function BannerService($resource, ENV) {
    var data = {
      loading: false,
      data: []
    };
    var resource = $resource(ENV.api + '/banner');

    return {
      getData: getData,
      fetch: fetch
    };

    function getData() {
      return data;
    }

    function fetch() {
      data.loading = true;

      resource.get(onSuccess, onError);

      function onSuccess(response) {
        if (!response.success) {
          onError();
        }

        data.data = response.data.slice(0,3);
        data.loading = false;
      }

      function onError() {
        data.loading = false;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .factory('AdminService', AdminService);

  /** @ngInject */
  function AdminService($resource, $window, ENV) {
    var data = {
      loading: false
    };

    return {
      getData: getData,
      logIn: logIn
    };

    function getData() {
      return data;
    }

    function logIn(credentials, errCallback) {
      if (ENV.name === 'local') {
        redirectToAdmin();
        return;
      }

      data.loading = true;
      $resource(ENV.api + '/login').save(credentials, onSuccess, onError);

      function onSuccess(res) {
        var role = res && res.user && res.user.role;

        if (!res.success || !role) {
          onError();
          return;
        }

        data.loading = false;
        redirectToAdmin();
      }

      function onError(res) {
        var msg = res && res.data && res.data.error && res.data.error.message ||
          'Unknown error has occurred. Please try again in a little while.';

        errCallback && errCallback(msg);
        data.loading = false;
      }

      function redirectToAdmin() {
        $window.location = 'http://' + $window.location.hostname + ENV.adminURL;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .controller('ClientController', ClientController);

  /** @ngInject */
  function ClientController($scope, $document, $timeout, DictionaryService, StaffService, NewsService, ProjectsService) {
    var vm = this;

    vm.dictionary = DictionaryService.getData();
    vm.menuOpened = false;
    vm.loginShowing = false;
    vm.scroller = {
      scroll: function (selector, tab, skipTimeout) {
        var wrapper = $document.find(selector);

        if (skipTimeout) {
          scroll();
        } else {
          $timeout(scroll, 300);
        }

        function scroll() {
          $document.duScrollToElementAnimated(wrapper, 0, 1000);
        }
      }
    };

    vm.closeMenu = closeMenu;

    init();

    function init() {
      var destroyListener = $scope.$watch('client.menuOpened', function (newValue) {
        if (newValue) {
          vm.backDropToRight = true;
        } else {
          $timeout(function () {
            vm.backDropToRight = false;
          }, 400);
        }
      });
      $scope.$on('$destroy', destroyListener);

      DictionaryService.fetch({forClient: true});
      StaffService.fetch();
      NewsService.fetch();
      ProjectsService.fetch();
    }

    function closeMenu() {
      vm.menuOpened = false;
      angular.element('body').removeClass('no-scroll');
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('Debug enabled, runBlock end.');
  }

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('client', {
        url: '',
        abstract: true,
        templateUrl: 'app/pages/client.html',
        controller: 'ClientController',
        controllerAs: 'client'
      })
      .state('client.home', {
        url: '/home',
        templateUrl: 'app/pages/home/home.html',
        controller: 'HomeController',
        controllerAs: 'home'
      })
      .state('client.team', {
        url: '/team',
        templateUrl: 'app/pages/team/team.html',
        controller: 'TeamController',
        controllerAs: 'team'
      })
      .state('client.strategy', {
        url: '/investment-strategy',
        templateUrl: 'app/pages/strategy/strategy.html',
        controller: 'StrategyController',
        controllerAs: 'strategy'
      })
      .state('client.projects', {
        url: '/projects',
        templateUrl: 'app/pages/projects/projects.html',
        controller: 'ProjectsController',
        controllerAs: 'projects'
      })
      .state('client.news', {
        url: '/news',
        templateUrl: 'app/pages/news/news.html',
        controller: 'NewsController',
        controllerAs: 'news'
      })
      .state('client.press-releases', {
        url: '/news/press-releases',
        templateUrl: 'app/pages/news/press-releases/press-releases.html',
        controller: 'NewsController',
        controllerAs: 'news'
      })
      .state('client.publications', {
        url: '/news/publications',
        templateUrl: 'app/pages/news/publications/publications.html',
        controller: 'NewsController',
        controllerAs: 'news'
      })
      .state('client.archive', {
        url: '/news/archive',
        templateUrl: 'app/pages/news/archive/archive.html',
        controller: 'NewsController',
        controllerAs: 'news'
      })
      .state('client.testimonials', {
        url: '/news/testimonials',
        templateUrl: 'app/pages/news/testimonials/testimonials.html',
        controller: 'NewsController',
        controllerAs: 'news'
      })
      .state('client.contact-us', {
        url: '/contact-us',
        templateUrl: 'app/pages/contact-us/contact-us.html',
        controller: 'ContactUsController',
        controllerAs: 'contactUs'
      });

    $urlRouterProvider.otherwise('/home');
  }

})();


(function () {
  'use strict';

  angular
    .module('ifh');
    //.constant();

})();

(function () {
  'use strict';

  angular
    .module('ifh')
    .config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, ENV, uiGmapGoogleMapApiProvider) {
    // Enable log
    $logProvider.debugEnabled(ENV.debugEnabled);

    $httpProvider.interceptors.push('HttpInterceptors');

    $httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.headers.common.Accept = 'application/json';
    $httpProvider.defaults.headers.common['Content-Type'] = 'application/json';
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyBsZLlZ9j9bwOuAvOisoTOFoCg0yNwR3TY',
      v: '3.22'
    });
  }

})();

angular.module("ifh.ENV", [])
.constant("ENV", {"name":"prod","api":"/api","adminURL":"/admin","debugEnabled":false});

angular.module("ifh").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/client.html","<div class=\"client-wrapper\"><ifh-client-loader ng-show=\"client.dictionary.fetching\"></ifh-client-loader><div ng-hide=\"client.dictionary.fetching\" class=\"client-content\"><ifh-menu ng-class=\"{opened: client.menuOpened}\" opened=\"client.menuOpened\" scroller=\"client.scroller\" dictionary=\"client.dictionary.data\"></ifh-menu><ifh-menu-toggle ng-class=\"{opened: client.menuOpened}\" menu-opened=\"client.menuOpened\"></ifh-menu-toggle><ifh-header ng-class=\"{opened: client.menuOpened}\" menu-opened=\"client.menuOpened\" login-showing=\"client.loginShowing\" dictionary=\"client.dictionary.data\"></ifh-header><ifh-login-dialog ng-class=\"{showing: client.loginShowing}\" showing=\"client.loginShowing\"></ifh-login-dialog><div ng-click=\"client.closeMenu()\" ng-class=\"{visible: client.menuOpened, right: client.backDropToRight}\" class=\"menu-backdrop\"></div><div ui-view=\"\"></div><ifh-footer></ifh-footer></div></div>");
$templateCache.put("app/components/director-card/director-card.html","<div class=\"img\"><div class=\"inner\" style=\"background-image: url(\'{{::vm.imgPrefix}}{{::vm.director.image}}\')\"></div></div><div class=\"info\"><div class=\"name\">{{::vm.director.name}}</div><div class=\"title\" ng-if=\"vm.director.title\">{{::vm.director.title}}</div><div ng-bind-html=\"::vm.director.description\" class=\"description\"></div></div>");
$templateCache.put("app/components/footer/footer.html","<div layout=\"column\" layout-gt-xs=\"row\" class=\"footer\"><div layout=\"column\" layout-gt-md=\"row\" class=\"left\"><div class=\"padding\"><span class=\"label\">phone:</span> <a href=\"tel:+1{{::client.dictionary.data.contactPhone}}\" class=\"contact\">{{::client.dictionary.data.contactPhone}}</a></div><div class=\"padding\"><span class=\"label\">fax:</span> <span>{{::client.dictionary.data.contactFax}}</span></div><div class=\"padding\"><span class=\"label\">e-mail:</span> <a href=\"mailto:{{::client.dictionary.data.contactEmail}}\" class=\"contact\">{{::client.dictionary.data.contactEmail}}</a></div></div><div hide-xs=\"\" flex=\"\"></div><div class=\"right\" layout=\"column\" layout-gt-md=\"row\" layout-align-gt-md=\"end top\"><div class=\"copy padding\">© 2012-{{::vm.currentYear}}, {{::client.dictionary.data.contactCompanyName}}</div><div hide-xs=\"\" hide-sm=\"\" hide-md=\"\" class=\"splitter\">|</div><div class=\"developed padding\">Developed by <a href=\"http://sprinterra.com/\" class=\"dio\" target=\"_blank\">Sprinterra</a></div></div></div>");
$templateCache.put("app/components/header/header.html","<div class=\"header\" layout=\"row\"><div flex=\"\"></div><div flex=\"\" class=\"logo\"><a ui-sref=\"client.home\"><img src=\"assets/images/logo.png\" title=\"{{::vm.dictionary.contactCompanyName}} logo\"></a></div><div flex=\"\" class=\"login-center no-select\" layout=\"row\" layout-align=\"end center\"><span ng-click=\"vm.openLoginPopup()\">{{::vm.dictionary.homeLogin}}</span></div></div>");
$templateCache.put("app/components/loader/loader.html","<div layout=\"row\" class=\"\" style=\"height: 100vh\"><div flex=\"\"></div><div layout=\"column\"><div flex=\"\"></div><div class=\"sk-folding-cube\"><div class=\"sk-cube1 sk-cube\"></div><div class=\"sk-cube2 sk-cube\"></div><div class=\"sk-cube4 sk-cube\"></div><div class=\"sk-cube3 sk-cube\"></div></div><div flex=\"\"></div></div><div flex=\"\"></div></div>");
$templateCache.put("app/components/login-dialog/login-dialog.html","<div ng-click=\"vm.closePopUp($event)\" class=\"backdrop\" layout=\"column\"><div flex=\"\"></div><div layout=\"row\"><div flex=\"\"></div><form ng-submit=\"vm.login()\" class=\"login\"><div class=\"outline\"><div layout=\"row\" class=\"input-wrapper\"><div class=\"left\" layout=\"row\" layout-align=\"center\"><i class=\"fa fa-user\" aria-hidden=\"true\"></i></div><input flex=\"\" ng-model=\"vm.credentials.login\" type=\"text\" autocorrect=\"off\" placeholder=\"Login\" required=\"\"></div><div layout=\"row\" class=\"input-wrapper\"><div class=\"left\" layout=\"row\" layout-align=\"center\"><i class=\"fa fa-lock\" aria-hidden=\"true\"></i></div><input flex=\"\" ng-model=\"vm.credentials.password\" type=\"password\" placeholder=\"Password\" required=\"\"></div><div ng-if=\"vm.error\" class=\"error-wrapper\"><p class=\"error\">{{vm.error}}</p></div><div layout=\"row\"><div flex=\"\" class=\"call-to-action\"><button ng-class=\"{disabled: vm.adminData.loading}\" type=\"submit\" class=\"georgia\">Log in</button></div></div></div></form><div flex=\"\"></div></div><div flex=\"\"></div></div>");
$templateCache.put("app/components/menu/menu.html","<div ng-if=\"vm.opened\" ng-scrollbars=\"\" ng-scrollbars-config=\"vm.config\" class=\"menu\"><div ng-repeat=\"link in vm.links\" ng-click=\"vm.navigate(link.state, link.activateTab)\" ng-class=\"{active: link.isActive}\" class=\"menu-item {{link.isSubItem ? \'sub-item\' : \'\'}}\"><i class=\"material-icons\">arrow_forward</i> <span>{{::vm.dictionary[link.text]}}</span></div></div>");
$templateCache.put("app/components/menu-toggle/menu-toggle.html","<div flex=\"\" ng-click=\"vm.toggleMenu()\" layout=\"row\" class=\"menu-toggle no-select\" layout-align=\"start center\"><div class=\"burger\"><div></div><div></div><div></div></div></div>");
$templateCache.put("app/components/news-categories/news-categories.html","<div layout=\"row\" layout-align=\"center center\" class=\"categories\"><h3 ng-repeat=\"link in vm.links\" ng-click=\"vm.changeType(link.state)\" ng-class=\"{active: link.state === vm.activeState}\" class=\"link\">{{::client.dictionary.data[link.text]}}</h3></div>");
$templateCache.put("app/components/news-dialog/news-dialog.html","<div ng-class=\"{open: vm.data.open}\" class=\"member-wrapper news-dialog-wrapper\"><i ng-click=\"vm.closeDialog()\" class=\"close material-icons\">close</i><div id=\"news-dialog-content\" class=\"content\"><div class=\"date dialog-date\">{{::vm.data.content.date | date:\'mediumDate\'}}</div><div class=\"title\">{{::vm.data.content.name}}</div><div ng-bind-html=\"vm.data.content.content\"></div></div></div>");
$templateCache.put("app/components/project-card/project-card.html","<div ng-click=\"projectCard.openDialog()\" class=\"project\"><div class=\"img\"><div class=\"inner\" style=\"background-image: url(\'{{::projectCard.project.timelineImg}}\')\"></div></div><p class=\"project-title\">{{::projectCard.project.name}}</p><p class=\"learn-more\">View project</p></div><ifh-project-dialog data=\"projectCard.projectDialog\"></ifh-project-dialog>");
$templateCache.put("app/components/project-card-completed/project-card-completed.html","<div class=\"project\"><div class=\"img\"><div class=\"inner\" style=\"background-image: url(\'{{::projectCardCompleted.project.timelineImg}}\')\"></div></div><p class=\"project-title\">{{::projectCardCompleted.project.name}}</p><div class=\"info\">{{::projectCardCompleted.project.location}} <span ng-if=\"projectCardCompleted.project.location && projectCardCompleted.project.projectSize || projectCardCompleted.project.year\" class=\"vertical-splitter\">|</span> {{::projectCardCompleted.project.projectSize}} <span ng-if=\"projectCardCompleted.project.projectSize && projectCardCompleted.project.year\" class=\"vertical-splitter\">|</span> {{::projectCardCompleted.project.year}}</div><div class=\"description\" ng-bind-html=\"projectCardCompleted.project.description\"></div></div>");
$templateCache.put("app/components/project-dialog/project-dialog.html","<div ng-class=\"{open: vm.data.open}\" class=\"member-wrapper project-wrapper\"><i ng-click=\"vm.closeDialog()\" class=\"close material-icons\">close</i><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\" flex-gt-sm=\"50\" class=\"gallery\"><div class=\"no-image\" ng-if=\"!vm.data.project.images.length\"></div><slick ng-if=\"vm.data.project.images.length\" infinite=\"true\" speed=\"500\" autoplayspeed=\"5000\" fade=\"true\" autoplay=\"true\" cssease=\"linear\"><div class=\"item\" ng-repeat=\"image in vm.data.project.images\"><div class=\"image\" style=\"background-image: url(\'{{::vm.imgPrefix}}{{image}}\')\"></div></div></slick></div><div flex=\"100\" flex-gt-sm=\"50\" class=\"js-dialog-content content\"><h2 class=\"name\" style=\"margin-bottom: 0\">{{vm.data.project.name}}</h2><h3>{{vm.data.project.location}} <span ng-if=\"vm.data.project.location && vm.data.project.projectSize || vm.data.project.year\" class=\"vertical-splitter\">|</span> {{vm.data.project.projectSize}} <span ng-if=\"vm.data.project.projectSize && vm.data.project.year\" class=\"vertical-splitter\">|</span> {{vm.data.project.year}}</h3><ifh-splitter type=\"2\"></ifh-splitter><div class=\"description\" ng-bind-html=\"vm.data.project.description\"></div><div layout=\"row\" class=\"bottom-buttons\"><div ng-if=\"vm.data.previous.id\" ng-click=\"vm.data.selectedID = vm.data.previous.id;\" layout=\"row\" layout-align=\"start center\" class=\"bottom-button left no-select\"><div><img src=\"assets/images/arrow-left.png\"></div><div style=\"padding-left: 6px;\"><p class=\"btn-title\">previous</p><p class=\"btn-name\">{{vm.data.previous.name}}</p></div></div><div flex=\"\"></div><div ng-if=\"vm.data.next.id\" ng-click=\"vm.data.selectedID = vm.data.next.id;\" layout=\"row\" layout-align=\"end center\" class=\"bottom-button right no-select\"><div style=\"padding-right: 6px;\"><p class=\"btn-title right\">next</p><p class=\"btn-name\">{{vm.data.next.name}}</p></div><div><img src=\"assets/images/arrow-right.png\"></div></div></div></div></div></div>");
$templateCache.put("app/components/projects-timeline/proejcts-timeline.html","<div class=\"timeline\"><div layout=\"row\" hide-xs=\"\" hide-sm=\"\" class=\"timeline-years\"><div ng-repeat=\"year in timeline.data\" flex=\"\" class=\"year\" layout=\"column\"><div class=\"line-wrapper\" layout=\"row\"><div flex=\"\" ng-class=\"{\'no-border\': $first}\" class=\"line\"></div><div ng-click=\"timeline.scrollTo(year.year)\" class=\"dot\"></div><div flex=\"\" ng-class=\"{\'no-border\': $last}\" class=\"line\"></div></div><div class=\"year\"><span ng-click=\"timeline.scrollTo(year.year)\">{{::year.year}}</span></div></div></div><div class=\"wrapper\"><div class=\"timeline-projects\"><div ng-repeat=\"year in timeline.data\" class=\"projects-in-year year{{::year.year}}\"><div layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div flex=\"100\" flex-gt-xs=\"50\" flex-order-gt-xs=\"{{$odd ? 1 : 0}}\" layout=\"row\" layout-align=\"center center\"><div hide-xs=\"\" hide-sm=\"\" flex=\"\"><ifh-splitter type=\"3\"></ifh-splitter></div><div flex=\"\" class=\"year\">{{::year.year}}</div><div hide-xs=\"\" hide-sm=\"\" flex=\"\"><ifh-splitter type=\"4\"></ifh-splitter></div></div><div flex=\"100\" flex-gt-xs=\"50\" flex-order-gt-xs=\"{{$odd ? 0 : 1}}\" ng-class=\"{odd: $odd, even: $even}\"><ifh-project-card-completed ng-repeat=\"project in year.projects\" project=\"project\"></ifh-project-card-completed></div></div></div></div></div></div>");
$templateCache.put("app/components/splitter/splitter.html","<div ng-if=\"vm.type === 0\" class=\"main-splitter\"><img src=\"assets/images/splitters/0.png\"></div><div ng-if=\"vm.type === 1\" class=\"double-splitter\"><div></div><div></div></div><div ng-if=\"vm.type === 2\" class=\"splitter-second-type\"><img src=\"assets/images/splitters/2.png\"></div><div ng-if=\"vm.type === 3\" class=\"splitter-third-type\"><img src=\"assets/images/splitters/3.png\"></div><div ng-if=\"vm.type === 4\" class=\"splitter-fourth-type\"><img src=\"assets/images/splitters/4.png\"></div><div ng-if=\"vm.type === 5\" layout=\"row\" layout-align=\"center center\" class=\"splitter-fifth-type\"><div class=\"square\"></div><div flex=\"\" class=\"line\"></div></div>");
$templateCache.put("app/components/team-member/team-member.html","<div ng-click=\"vm.openMemberDialog()\" class=\"member-avatar\"><div class=\"img\"><div class=\"inner\" style=\"background-image: url(\'{{::vm.imgPrefix}}{{::vm.member.image}}\')\"></div></div><div class=\"description\"><div class=\"name\">{{::vm.member.name}}</div><div class=\"title\" ng-if=\"vm.member.title\">{{::vm.member.title}}</div></div></div>");
$templateCache.put("app/components/team-member-dialog/team-member-dialog.html","<div ng-class=\"{open: vm.data.open}\" class=\"member-wrapper\"><i ng-click=\"vm.closeDialog()\" class=\"close no-select material-icons\">close</i><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\" flex-gt-sm=\"50\" class=\"avatar\" style=\"background-image: url(\'{{::vm.imgPrefix}}{{vm.currentMember.thumbnail}}\')\"></div><div flex=\"100\" flex-gt-sm=\"50\" class=\"info\"><div class=\"scroll-wrapper\"><h2 class=\"name\">{{vm.currentMember.name}}</h2><h3 class=\"title\">{{vm.currentMember.title}}</h3><ifh-splitter type=\"2\"></ifh-splitter><div class=\"description\" ng-bind-html=\"vm.currentMember.description\"></div></div><div hide-xs=\"\" hide-sm=\"\" layout=\"row\" class=\"bottom-buttons\"><div ng-if=\"vm.previous.id\" ng-click=\"vm.data.selectedID = vm.previous.id;\" layout=\"row\" layout-align=\"start center\" class=\"bottom-button left no-select\"><div><img src=\"assets/images/arrow-left.png\"></div><div style=\"padding-left: 6px;\"><p class=\"btn-title\">previous</p><p class=\"btn-name\">{{vm.previous.name}}</p></div></div><div flex=\"\"></div><div ng-if=\"vm.next.id\" ng-click=\"vm.data.selectedID = vm.next.id;\" layout=\"row\" layout-align=\"end center\" class=\"bottom-button right no-select\"><div style=\"padding-right: 6px;\"><p class=\"btn-title right\">next</p><p class=\"btn-name\">{{vm.next.name}}</p></div><div><img src=\"assets/images/arrow-right.png\"></div></div></div></div></div></div>");
$templateCache.put("app/components/video-dialog/video-dialog.html","<div ng-class=\"{open: vm.data.open}\" class=\"member-wrapper video-wrapper\"><i ng-click=\"vm.closeDialog()\" class=\"close material-icons\">close</i> {{::vm.data.video}}</div>");
$templateCache.put("app/pages/contact-us/contact-us.html","<div class=\"contact-us-wrapper\"><div class=\"header-img\" layout=\"column\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuContactUs}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\" flex-gt-sm=\"66\" class=\"section texture-bg contacts\"><h2>{{::client.dictionary.data.menuContactUs}}</h2><ifh-splitter type=\"0\"></ifh-splitter><div layout=\"row\" layout-wrap=\"\"><div flex=\"100\" flex-gt-md=\"50\"><p><b>{{::client.dictionary.data.contactCompanyName}}</b></p><p class=\"gray\">{{::client.dictionary.data.contactAddress}}</p></div><div flex=\"100\" flex-gt-md=\"50\"><p><b><span class=\"label\">phone:</span> <a href=\"tel:+1{{::client.dictionary.data.contactPhone}}\" class=\"contact\">{{::client.dictionary.data.contactPhone}}</a></b></p><p><b><span class=\"label\">fax:</span> <span class=\"contact\">{{::client.dictionary.data.contactFax}}</span></b></p><p><b><span class=\"label\">e-mail:</span> <a href=\"mailto:{{::client.dictionary.data.contactEmail}}\" class=\"contact\">{{::client.dictionary.data.contactEmail}}</a></b></p></div></div><ifh-splitter type=\"1\"></ifh-splitter><div ng-if=\"!contactUs.data.fetching && !contactUs.data.submitted\"><div class=\"contact-title\">{{::client.dictionary.data.contactFormTitle}}</div><p class=\"contact-text\">{{::client.dictionary.data.contactFormSubTitle}}</p><form ng-submit=\"contactUs.getInTouch()\" name=\"contactUs.form\" layout=\"row\" layout-wrap=\"\" class=\"contact-form\"><p class=\"error\" ng-if=\"contactUs.data.showError\">{{::client.dictionary.data.contactUsError}}</p><div flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\"><div class=\"item\"><label class=\"label\" for=\"sender\">Name:</label> <input ng-model=\"contactUs.data.data.name\" ng-class=\"{submitted: contactUs.submitted}\" class=\"input-text\" type=\"text\" name=\"name\" id=\"sender\" maxlength=\"255\" required=\"\"></div><div class=\"item\"><label class=\"label\" for=\"phone\">Phone:</label> <input ng-model=\"contactUs.data.data.phone\" ng-class=\"{submitted: contactUs.submitted}\" class=\"input-text\" type=\"tel\" name=\"name\" id=\"phone\" maxlength=\"15\" required=\"\"></div><div class=\"item\"><label class=\"label\" for=\"email\">E-mail:</label> <input ng-model=\"contactUs.data.data.email\" ng-class=\"{submitted: contactUs.submitted}\" class=\"input-text\" type=\"email\" name=\"name\" id=\"email\" maxlength=\"255\" required=\"\"></div></div><div flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"50\" class=\"question-wrapper\"><label class=\"label\" for=\"question\">Question:</label> <textarea ng-model=\"contactUs.data.data.question\" ng-class=\"{submitted: contactUs.submitted}\" class=\"textarea\" name=\"question\" id=\"question\" maxlength=\"1000\" required=\"\">\r\n            </textarea></div><div class=\"call-to-action\"><button type=\"submit\">{{::client.dictionary.data.contactFormSend}}</button></div></form></div><div ng-if=\"contactUs.data.fetching\" layout=\"row\" class=\"contact-loader\"><div flex=\"\"></div><div class=\"sk-folding-cube\"><div class=\"sk-cube1 sk-cube\"></div><div class=\"sk-cube2 sk-cube\"></div><div class=\"sk-cube4 sk-cube\"></div><div class=\"sk-cube3 sk-cube\"></div></div><div flex=\"\"></div></div><div ng-if=\"contactUs.data.submitted\"><div class=\"contact-title\">{{::client.dictionary.data.contactSubmittedTitle}}</div><p class=\"contact-text\">{{::client.dictionary.data.contactFormSubmittedMessage}}</p></div></div><div flex=\"100\" flex-gt-sm=\"33\" class=\"angular-google-map-wrapper\"><ui-gmap-google-map center=\"contactUs.map.center\" zoom=\"contactUs.map.zoom\" refresh=\"contactUs.map.refresh\" control=\"contactUs.map.control\" pan=\"true\" class=\"angular-google-map\"></ui-gmap-google-map></div></div></div>");
$templateCache.put("app/pages/home/home.html","<div class=\"preload-images\"><img src=\"/assets/images/headers/main_old.jpg\" alt=\"\"> <img src=\"/assets/images/headers/main_pic1.jpg\" alt=\"\"> <img src=\"/assets/images/headers/main_pic2.jpg\" alt=\"\"> <img src=\"/assets/images/headers/main_pic3.jpg\" alt=\"\"> <img src=\"/assets/images/headers/main_pic4.jpg\" alt=\"\"></div><div class=\"home-wrapper\"><div class=\"home-slider\"><div class=\"current slide-1\"></div><div class=\"next slide-2\"></div></div><div class=\"home-inner\"><div layout=\"column\" class=\"call-to-action-wrapper\"><div flex=\"\"></div><div layout=\"row\"><div flex=\"\"></div><div><h3 class=\"sub-slogan\">{{::client.dictionary.data.homeDescription}}</h3><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"slogan-wrapper\"><h1 class=\"slogan\" ng-bind-html=\"client.dictionary.data.homeSlogan\"></h1></div></div></div><ifh-video-dialog data=\"home.videoDialog\"></ifh-video-dialog></div><div class=\"about-wrapper section\"><h2>{{::client.dictionary.data.menuAbout}}</h2><ifh-splitter type=\"0\"></ifh-splitter><p class=\"description\">{{::client.dictionary.data.aboutText}}</p><ifh-splitter type=\"1\"></ifh-splitter><div class=\"banner-wrapper\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div ng-repeat=\"banner in home.banners.data track by $index\" class=\"banner-item\" flex=\"33\" flex-xs=\"100\"><img src=\"{{::home.imgPrefix}}{{::banner.image}}\" alt=\"{{::banner.title}}\"></div></div><ifh-splitter type=\"1\"></ifh-splitter><h3 class=\"text-center\">{{::client.dictionary.data.aboutStructure}}</h3><div class=\"structure-wrapper\"><img src=\"assets/images/logoDark.png\" alt=\"Interforum Holdings, Inc. logo\" class=\"logo\"><div class=\"block-title\">Interforum Holdings, Inc.<br><div class=\"block-sub-title\">Multifamily Development</div></div><div layout=\"row\" layout-wrap=\"\" class=\"list\"><div class=\"item\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\"><a href=\"http://www.manageatggi.com/\" class=\"link\" target=\"_blank\"><img src=\"assets/images/structure/logo1.png\" alt=\"GGI Properties logo\" class=\"image\"></a><div class=\"title\">GGI Properties</div><div class=\"block-description\">Property Management Division</div></div><div class=\"item\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\"><a href=\"http://c3condo.com/\" class=\"link\" target=\"_blank\"><img src=\"assets/images/structure/logo2.png\" alt=\"C3 logo\" class=\"image\"></a><div class=\"title\">Chicago Condo Collection</div><div class=\"block-description\">Condo &amp; Townhome Development</div></div><div class=\"item\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\"><a href=\"http://dreamhomesdevelopers.com/\" class=\"link\" target=\"_blank\"><img src=\"assets/images/structure/logo3.png\" alt=\"DHD logo\" class=\"image\"></a><div class=\"title\">Dream Homes developers</div><div class=\"block-description\">Suburban Single Family Home Development</div></div><div class=\"item\" flex=\"100\" flex-xs=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\"><a href=\"http://land2house.com/\" class=\"link\" target=\"_blank\"><img src=\"assets/images/structure/logo4.png\" alt=\"Land2House logo\" class=\"image\"></a><div class=\"title\">Land2House</div><div class=\"block-description\">Chicago Custom Home Development</div></div></div></div><h3 class=\"stats-title\">{{::client.dictionary.data.aboutStats}}</h3><div class=\"stats-wrapper\"><div ng-repeat=\"stat in home.stats.data track by $index\" layout=\"row\" layout-align=\"center center\" class=\"stat\"><div flex=\"\" class=\"stat-left\"><span class=\"indicator-text\">{{::stat.indicatorTxt}}</span> <span class=\"qty\">{{::stat.qty}}</span></div><div class=\"icon-wrapper\"><i class=\"fa {{::stat.icon}}\"></i></div><div flex=\"\" class=\"stat-right\"><div class=\"inner\">{{::stat.text}}</div></div></div></div></div>");
$templateCache.put("app/pages/news/news.html","<div class=\"news-wrapper\"><div class=\"layout-column header-img\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuNewsRoom}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"section\"><h2>{{::client.dictionary.data.menuNewsRoom}}</h2><ifh-splitter type=\"0\"></ifh-splitter><ifh-news-categories></ifh-news-categories></div><ifh-news-dialog data=\"news.newsDialog\"></ifh-news-dialog></div>");
$templateCache.put("app/pages/projects/projects.html","<div class=\"projects-wrapper section\"><div class=\"header-img\" layout=\"column\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuProjects}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"header-wrapper\"><h2>{{::client.dictionary.data.menuProjects}}</h2><ifh-splitter type=\"0\"></ifh-splitter><div layout=\"row\" layout-align=\"center center\"><h3 ng-click=\"projects.showProjectTypeSelect()\" ng-class=\"{active: projects.activeTab === 0}\" class=\"link\">{{::client.dictionary.data.menuProjectsCurrent}}</h3><h3 ng-click=\"projects.showFinishedProjects();\" ng-class=\"{active: projects.activeTab === 1}\" class=\"link\">{{::client.dictionary.data.menuProjectsFinished}}</h3></div><div ng-show=\"projects.currentType != undefined\" layout=\"row\" layout-align=\"center center\"><h3 ng-click=\"projects.showCurrent(0)\" ng-class=\"{active: projects.currentType === 0}\" class=\"link\">{{::client.dictionary.data.menuProjectsMulti}}</h3><h3 ng-click=\"projects.showCurrent(1)\" ng-class=\"{active: projects.currentType === 1}\" class=\"link\">{{::client.dictionary.data.menuProjectsSingle}}</h3><h3 ng-click=\"projects.showCurrent(2)\" ng-class=\"{active: projects.currentType === 2}\" class=\"link\">{{::client.dictionary.data.menuProjectsManagement}}</h3></div></div><div ng-if=\"projects.activeTab === 0\"><div ng-if=\"!projects.showCurrentList\" layout=\"column\" layout-gt-xs=\"row\" class=\"current-projects\"><div ng-click=\"projects.showCurrent(0)\" flex=\"\" class=\"type type1\"><div class=\"img img-bright\"></div><div class=\"img img-dark\"></div><div class=\"info\"><p class=\"title\">{{::client.dictionary.data.menuProjectsMulti}}</p><ifh-splitter type=\"5\"></ifh-splitter><p class=\"learn-more\">Learn more</p></div><div class=\"backdrop\"></div></div><div ng-click=\"projects.showCurrent(1)\" flex=\"\" class=\"type type2\"><div class=\"img img-bright\"></div><div class=\"img img-dark\"></div><div class=\"info\"><p class=\"title\">{{::client.dictionary.data.menuProjectsSingle}}</p><ifh-splitter type=\"5\"></ifh-splitter><p class=\"learn-more\">Learn more</p></div><div class=\"backdrop\"></div></div><div ng-click=\"projects.showCurrent(2)\" flex=\"\" class=\"type type3\"><div class=\"img img-bright\"></div><div class=\"img img-dark\"></div><div class=\"info\"><p class=\"title\">{{::client.dictionary.data.menuProjectsManagement}}</p><ifh-splitter type=\"5\"></ifh-splitter><p class=\"learn-more\">Learn more</p></div><div class=\"backdrop\"></div></div></div><div ng-if=\"projects.showCurrentList\" class=\"current-list\"><div class=\"list-wrapper\" layout-xs=\"column\" layout=\"row\" layout-wrap=\"\"><div ng-repeat=\"project in projects.currentProjects\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" class=\"card-wrapper\"><ifh-project-card project=\"project\"></ifh-project-card></div></div><p ng-if=\"!projects.currentProjects.length\" class=\"no-projects\">{{::client.dictionary.data.noProjectsInCategory}}</p></div></div><div ng-if=\"projects.activeTab === 1\" class=\"finished-projects\"><ifh-projects-timeline projects=\"projects.data.data.completed\"></ifh-projects-timeline></div></div>");
$templateCache.put("app/pages/strategy/strategy.html","<div class=\"strategy-wrapper\"><div class=\"header-img\" layout=\"column\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuInvestmentStrategy}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"section\"><h2>{{::client.dictionary.data.menuInvestmentStrategy}}</h2><ifh-splitter type=\"0\"></ifh-splitter><div class=\"description\"><p class=\"text\">{{::client.dictionary.data.investmentText}}</p><img src=\"assets/images/strategy.jpg\" alt=\"\" class=\"image\"></div><div class=\"layout-row\"><div flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\" class=\"item\"><div class=\"img location\"></div><h3 class=\"title location\">Location</h3><p class=\"block-text\">{{::client.dictionary.data.investmentLocation}}</p></div><div flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\" class=\"item\"><div class=\"img structure\"></div><h3 class=\"title structure\">Structure</h3><p class=\"block-text\">{{::client.dictionary.data.investmentStructure}}</p></div><div flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\" class=\"item\"><div class=\"img relationships\"></div><h3 class=\"title relationship\">Relationships</h3><p class=\"block-text\">{{::client.dictionary.data.investmentRelationships}}</p></div></div><div class=\"item investment\" layout-gt-sm=\"row\"><div flex-gt-sm=\"33\" class=\"img type\"></div><div flex-gt-sm=\"66\"><h3 class=\"title investment\">Investment type and character</h3><p class=\"block-text investment\">{{::client.dictionary.data.investmentType}}</p></div></div></div></div>");
$templateCache.put("app/pages/team/team.html","<div class=\"team-wrapper\"><div class=\"header-img\" layout=\"column\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuTeam}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><h2>{{::client.dictionary.data.menuTeam}}</h2><ifh-splitter type=\"0\"></ifh-splitter><div layout=\"row\" layout-align=\"center center\"><h3 ng-click=\"team.activeTab = 0;\" ng-class=\"{active: team.activeTab === 0}\" class=\"link\">{{::client.dictionary.data.menuAdvisers}}</h3><h3 ng-click=\"team.activeTab = 1;\" ng-class=\"{active: team.activeTab === 1}\" class=\"link\">{{::client.dictionary.data.menuManagers}}</h3><h3 ng-if=\"false\" ng-click=\"team.activeTab = 2;\" ng-class=\"{active: team.activeTab === 2}\" class=\"link\">{{::client.dictionary.data.menuDirectors}}</h3></div><div ng-if=\"team.activeTab === 0\" layout=\"row\" layout-wrap=\"\" class=\"texture-bg\"><ifh-team-member ng-repeat=\"adviser in team.data.executives\" member=\"adviser\" dialog-data=\"team.memberDialog\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"{{::team.getWidth(team.data.advisers.length)}}\"></ifh-team-member></div><div ng-if=\"team.activeTab === 1\" layout=\"row\" layout-wrap=\"\" class=\"texture-bg\"><ifh-team-member ng-repeat=\"manager in team.data.managers\" member=\"manager\" dialog-data=\"team.memberDialog\" flex=\"100\" flex-xs=\"50\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"{{::team.getWidth(team.data.managers.length)}}\"></ifh-team-member></div><div ng-if=\"team.activeTab === 2 && false\" class=\"directors\"><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap=\"\"><ifh-director-card ng-repeat=\"adviser in team.data.directors\" director=\"adviser\" flex=\"\" flex-gt-xs=\"50\"></ifh-director-card></div><h3>{{::client.dictionary.data.advisoryBoard}}</h3><ifh-splitter type=\"0\"></ifh-splitter><div layout=\"column\" layout-gt-xs=\"row\" layout-wrap=\"\"><ifh-director-card ng-repeat=\"adviser in team.data.advisers\" director=\"adviser\" flex=\"\" flex-gt-xs=\"50\"></ifh-director-card></div></div><ifh-team-member-dialog data=\"team.memberDialog\"></ifh-team-member-dialog></div>");
$templateCache.put("app/pages/news/archive/archive.html","<div class=\"news-wrapper archive-wrapper\" ng-init=\"news.initContent(\'archive\')\"><div class=\"layout-column header-img\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuArchive}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"section\"><h2>{{::client.dictionary.data.menuArchive}}</h2><ifh-splitter type=\"0\"></ifh-splitter><ifh-news-categories></ifh-news-categories><div class=\"news releases\" layout=\"row\"><div flex=\"100\" flex-gt-sm=\"25\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\"><div ng-repeat=\"newsArticle in news.data.data.archive track by $index\" ng-click=\"news.setContent($index, \'archive\')\" ng-class=\"{active: $index === news.activeContentIndex}\" class=\"news-link pointer\"><p class=\"date\">{{::newsArticle.date | date:\'MM/dd/yyyy\'}}</p><p class=\"title\">{{::newsArticle.name}}</p></div></div><div flex=\"\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\" class=\"news-content\"><div ng-bind-html=\"news.activeNewsArticle.content\"></div></div></div></div><ifh-news-dialog data=\"news.newsDialog\"></ifh-news-dialog></div>");
$templateCache.put("app/pages/news/press-releases/press-releases.html","<div class=\"news-wrapper press-releases-wrapper\" ng-init=\"news.initContent(\'releases\')\"><div class=\"layout-column header-img\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuReleases}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"section\"><h2>{{::client.dictionary.data.menuReleases}}</h2><ifh-splitter type=\"0\"></ifh-splitter><ifh-news-categories></ifh-news-categories><div class=\"news releases\" layout=\"row\"><div flex=\"100\" flex-gt-sm=\"25\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\"><div ng-repeat=\"newsArticle in news.data.data.releases track by $index\" ng-click=\"news.setContent($index, \'releases\')\" ng-class=\"{active: $index === news.activeContentIndex}\" class=\"news-link pointer\"><p class=\"date\">{{::newsArticle.date | date:\'MM/dd/yyyy\'}}</p><p class=\"title\">{{::newsArticle.name}}</p></div></div><div flex=\"\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\" class=\"news-content\"><div ng-bind-html=\"news.activeNewsArticle.content\"></div></div></div></div><ifh-news-dialog data=\"news.newsDialog\"></ifh-news-dialog></div>");
$templateCache.put("app/pages/news/publications/publications.html","<div class=\"news-wrapper publications-wrapper\" ng-init=\"news.initContent(\'publications\')\"><div class=\"layout-column header-img\"><div flex=\"\"></div><div><h2>{{::client.dictionary.data.menuPublications}}</h2><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"section\"><h2>{{::client.dictionary.data.menuPublications}}</h2><ifh-splitter type=\"0\"></ifh-splitter><ifh-news-categories></ifh-news-categories><div hide-gt-sm=\"\" class=\"news publications\"><div ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\"><div ng-repeat=\"newsArticle in news.data.data.publications track by $index\" ng-class=\"{active: $index === news.activeContentIndex}\" class=\"news-link\"><p class=\"date\">{{::newsArticle.date | date:\'MM/dd/yyyy\'}}</p><p class=\"title\"><a class=\"title-link\" target=\"_blank\" href=\"{{::news.imgPrefix}}{{::newsArticle.content}}\">{{::newsArticle.name}}</a></p><div ng-if=\"newsArticle.file\" class=\"call-to-action\"><a ng-href=\"{{::news.imgPrefix}}{{::newsArticle.file}}\" target=\"_blank\">View File</a></div></div></div></div><div hide-xs=\"\" hide-sm=\"\" class=\"news releases\" layout=\"row\"><div flex=\"100\" flex-gt-sm=\"25\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\"><div ng-repeat=\"newsArticle in news.data.data.publications track by $index\" ng-click=\"news.setContent($index, \'publications\')\" ng-class=\"{active: $index === news.activeContentIndex}\" class=\"news-link pointer\"><p class=\"date\">{{::newsArticle.date | date:\'MM/dd/yyyy\'}}</p><p class=\"title\">{{::newsArticle.name}}</p></div></div><div flex=\"\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\" class=\"news-content\"><p class=\"title\" style=\"margin-top: 0;\">{{news.activeNewsArticle.name}}</p><div ng-if=\"news.activeNewsArticle.file\" class=\"call-to-action\" style=\"margin-bottom: 27px;\"><a ng-href=\"{{::news.imgPrefix}}{{news.activeNewsArticle.file}}\" download=\"{{::news.imgPrefix}}{{news.activeNewsArticle.file}}\">Download File</a></div><div ng-if=\"news.activeNewsArticle.file.indexOf(\'.pdf\') > -1\"><iframe ng-src=\"{{news.trustSrc(news.activeNewsArticle.file)}}\" style=\"width:100%; height:500px;\" frameborder=\"0\"></iframe></div><div ng-if=\"news.activeNewsArticle.file.indexOf(\'.png\') > -1 || news.activeNewsArticle.file.indexOf(\'.jpg\') > -1 || news.activeNewsArticle.file.indexOf(\'.jpeg\') > -1\"><img style=\"max-width: 100%\" ng-src=\"{{::news.imgPrefix}}{{news.activeNewsArticle.file}}\" alt=\"{{news.activeNewsArticle.file}}\"></div></div></div></div></div><ifh-news-dialog data=\"news.newsDialog\"></ifh-news-dialog>");
$templateCache.put("app/pages/news/testimonials/testimonials.html","<div class=\"news-wrapper testimonials-wrapper\" ng-init=\"news.initContent(\'testimonials\')\"><div class=\"layout-column header-img\"><div flex=\"\"></div><div><ifh-splitter type=\"0\"></ifh-splitter></div><div flex=\"\"></div></div><div class=\"section\"><h2>{{::client.dictionary.data.menuTestimonials}}</h2><ifh-splitter type=\"0\"></ifh-splitter><ifh-news-categories></ifh-news-categories><div hide-gt-sm=\"\" class=\"news testimonials\"><div ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\"><div ng-repeat=\"newsArticle in news.data.data.testimonials track by $index\" class=\"news-link\"><p class=\"date\">{{::newsArticle.date | date:\'MM/dd/yyyy\'}}</p><p class=\"title\"><a ng-href=\"{{::news.imgPrefix}}{{::newsArticle.file}}\" class=\"title-link\" target=\"_blank\">{{::newsArticle.name}}</a></p><div ng-if=\"newsArticle.file\" class=\"call-to-action\"><a ng-href=\"{{::news.imgPrefix}}{{::newsArticle.file}}\" target=\"_blank\">View File</a></div></div></div></div><div hide-xs=\"\" hide-sm=\"\" class=\"news releases\" layout=\"row\"><div flex=\"100\" flex-gt-sm=\"25\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\"><div ng-repeat=\"newsArticle in news.data.data.testimonials track by $index\" ng-click=\"news.setContent($index, \'testimonials\')\" ng-class=\"{active: newsArticle.id === news.activeNewsArticle.id}\" class=\"news-link pointer\"><p class=\"date\">{{::newsArticle.date | date:\'MM/dd/yyyy\'}}</p><p class=\"title\">{{::newsArticle.name}}</p></div></div><div flex=\"\" ng-scrollbars=\"\" ng-scrollbars-config=\"news.config\" class=\"news-content\"><p class=\"title\" style=\"margin-top: 0;\">{{news.activeNewsArticle.name}}</p><div ng-if=\"news.activeNewsArticle.file\" class=\"call-to-action\" style=\"margin-bottom: 27px;\"><a ng-href=\"{{::news.imgPrefix}}{{news.activeNewsArticle.file}}\" download=\"{{::news.imgPrefix}}{{news.activeNewsArticle.file}}\">Download File</a></div><div ng-if=\"news.activeNewsArticle.file.indexOf(\'.pdf\') > -1\"><iframe ng-src=\"{{news.trustSrc(news.activeNewsArticle.file)}}\" style=\"width:100%; height:500px;\" frameborder=\"0\"></iframe></div><div ng-if=\"news.activeNewsArticle.file.indexOf(\'.png\') > -1 || news.activeNewsArticle.file.indexOf(\'.jpg\') > -1 || news.activeNewsArticle.file.indexOf(\'.jpeg\') > -1\"><img style=\"max-width: 100%\" ng-src=\"{{::news.imgPrefix}}{{news.activeNewsArticle.file}}\" alt=\"{{news.activeNewsArticle.file}}\"></div></div></div></div><ifh-news-dialog data=\"news.newsDialog\"></ifh-news-dialog></div>");}]);